import { FeedbackOptions } from './feedback-options';
import { getFeedback } from './get-feedback';

export function feedbackCollector(options: FeedbackOptions) {
  return (overrides: Partial<FeedbackOptions> = {}) => {
    return getFeedback({ ...options, ...overrides });
  };
}
